<template>
    <div style="position:relative">
        <div class="poster-wrapper">
            <img v-if="!isPosterLoading" class="poster-img" :src="poster || defaultBanner" />
        </div>
        <Paper class="overlay-poster-img" :header="header">
            <div class="p-5 pb-7">
                <div v-if="!isLoading" v-html="description" />
                <PresentationSkeleton v-else />
            </div>
        </Paper>
    </div>
</template>

<script>
import PresentationSkeleton from '~/components/skeletons/PresentationSkeleton';
import CompanyBanner from '../../../assets/img/default-company-banner.jpg';
import ChatUserCarouselItem from './ChatUser.CarouselItem';
import { SHOW_CHAT_IN_COMPANY_PROFILE } from '~/router';
import AuthService from '~/services/AuthService';
import RestX from 'highered-utils/restx';
import DialogService from '~/services/DialogService';

export default {
    name: 'Presentation',
    components: { PresentationSkeleton },
    props: {
        description: { type: String, default: () => '' },
        poster: { type: String, default: () => '' },
        companyName: {
            type: String,
            optional: true,
            default: () => '',
        },
        companyCatchPhrase: {
            type: String,
            optional: true,
            default: () => '',
        },
        isLoading: Boolean,
        isPosterLoading: Boolean,
        chatUsers: Array,
    },
    data: () => ({
        defaultBanner: CompanyBanner,
    }),
    computed: {
        header() {
            if (this.companyName) {
                if (this.companyCatchPhrase) {
                    return `${this.companyName} - ${this.companyCatchPhrase}`;
                } else {
                    return this.companyName;
                }
            }
            return undefined;
        },
    },
    methods: {
        getCarouselComponent() {
            return ChatUserCarouselItem;
        },
        handleChatUserClick(item) {
            if (!AuthService.isLoggedIn()) {
                RestX.getInterfaces().logInModule.toggleOpen();
            }
            this.$root.$emit('chat-conversation-create-update', item.id);
        },
    },
};
</script>

<style scoped>
.poster-wrapper {
    z-index: -5;
    width: 100%;
    height: 170px;
    max-height: 170px;
    border-top-left-radius: var(--border-radius);
    border-top-right-radius: var(--border-radius);
}

.poster-img {
    position: relative;
    z-index: -1;
    width: 100%;
    height: 170px;
    max-height: 170px;
    object-fit: cover;
    border-top-left-radius: var(--border-radius);
    border-top-right-radius: var(--border-radius);
}
.overlay-poster-img {
    position: relative;
    top: calc(-1 * var(--border-radius));
    margin-bottom: calc(-1 * var(--border-radius));
}
</style>
